module.exports = __webpack_public_path__ + "static/img/img10.9a40509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/img10.png
// module id = rlzl
// module chunks = 1